import './src/main.css'
import Decoration5 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration5.name, Decoration5)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration5/index.js